const readStoredResult = (storage, key) => {
  try {
    const storedValue = storage?.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch {
    return null;
  }
};

const isNumberInRange = (value, minimum, maximum) => (
  Number.isFinite(value) && value >= minimum && value <= maximum
);

export const getRegistrationQuizSummary = (search, storage) => {
  const source = new URLSearchParams(search).get('source');

  if (source === 'aid-quiz') {
    const monthlyPotential = readStoredResult(storage, 'skipya_aid_quiz_result')?.result?.monthlyPotential;
    if (!isNumberInRange(monthlyPotential, 0, 10000)) return null;

    return {
      title: `Estimation conservée : jusqu'à ${monthlyPotential} €/mois`,
      detail: 'Créez votre compte pour vérifier vos droits, les justificatifs et les prochaines démarches.',
    };
  }

  if (source === 'tax-quiz') {
    const score = readStoredResult(storage, 'skipya_tax_quiz_result')?.result?.score;
    if (!isNumberInRange(score, 0, 100)) return null;

    return {
      title: `Score administratif conservé : ${score} %`,
      detail: 'Créez votre compte pour retrouver la checklist, les documents et les points de vigilance.',
    };
  }

  return null;
};

export const getAdministrativeScore = (storage) => {
  const score = readStoredResult(storage, 'skipya_tax_quiz_result')?.result?.score;
  return isNumberInRange(score, 0, 100) ? score : null;
};

export const TAX_QUIZ_KEY = 'skipya_tax_quiz_result';

export const getStoredTaxAnswers = (storage) => {
  const answers = readStoredResult(storage, TAX_QUIZ_KEY)?.answers;
  return answers && typeof answers === 'object' ? answers : null;
};
